var _ellipse, _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 127,
    viewBox: "0 0 91 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.5014,
    cy: 120.147,
    rx: 25.2517,
    ry: 12.6258,
    transform: "rotate(-35.3688 95.5014 120.147)",
    fill: "#94DBF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.264 41.1024L50.9858 35.6212L103.971 110.265C104.98 111.686 104.646 113.657 103.224 114.666L98.0763 118.32L43.264 41.1024Z",
    fill: "#307ACF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.8293,
    y: 45.6701,
    width: 7.89115,
    height: 94.6938,
    transform: "rotate(-35.3688 36.8293 45.6701)",
    fill: "#206087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1077 51.1514L36.8294 45.6701L91.6417 122.888L86.4939 126.542C85.0723 127.551 83.102 127.216 82.0929 125.795L29.1077 51.1514Z",
    fill: "#2A4C76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1068 51.1514L23.8733 32.1901L19.9624 17.4961C19.596 16.1179 21.0504 15.0854 22.2306 15.8861L34.8118 24.4254L50.9851 35.6213L46.004 44.9634L39.5692 49.5311L29.1068 51.1514Z",
    fill: "#94DBF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1378 21.9311L21.0167 15.0616C20.2991 14.5751 19.3622 15.2401 19.5848 16.0781L22.7307 27.8988L22.9821 27.853C26.3715 27.2383 29.3121 25.151 31.0105 22.154L31.1378 21.9311Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.12f28229f3a175c98d5e326adb3c21c4.svg";
export { ForwardRef as ReactComponent };